import {
  selectCurrentRefiUser,
  selectCurrentRefiVehicle,
  selectCurrentRefiApplication,
  selectCurrentRefi,
} from '../../reducers'

//Helper Functions

export const vehicleAndUserExists = (state) => {
  const vehicle = selectCurrentRefiVehicle(state)
  if (!vehicle.id) return false

  const user = selectCurrentRefiUser(state)
  if (!user.id) return false

  return true
}

export const ownershipUnknown = (state) => {
  const refiApp = selectCurrentRefiApplication(state)
  if (refiApp.owns === null && refiApp.manualVerification === null) return true

  return false
}

export const ownedOrManualVerification = (state) => {
  const refiApp = selectCurrentRefiApplication(state)
  if (refiApp.owns === true || refiApp.manualVerification === true) return true

  return false
}

export const refiExists = (state) => {
  const refi = selectCurrentRefi(state)
  if (refi.id) return true

  return false
}

//Profile Selector

/**
 * Always show the Personal Details (Create User) form.
 *
 * @returns {boolean} Always true.
 */
export const showCreateUser = (): boolean => true

//Ownership Selectors

export const showOwnershipCheck = (state) => {
  if (!vehicleAndUserExists(state)) return false
  if (refiExists(state)) return false

  return ownershipUnknown(state)
}

export const showOwnershipCheckFail = (state) => {
  if (!vehicleAndUserExists(state)) return false
  if (refiExists(state)) return false
  if (ownershipUnknown(state)) return false

  return !ownedOrManualVerification(state)
}

//SoftPull Selectors

export const showSoftPull = (state) => {
  if (!vehicleAndUserExists(state)) return false
  if (refiExists(state)) return false

  return ownedOrManualVerification(state)
}

export const showSoftPullFail = (state) => {
  if (!vehicleAndUserExists(state)) return false

  const refi = selectCurrentRefi(state)
  if (!refi.id) return false

  if (refi.loan.decision === 'DECLINED' || refi.loan.decision === 'ERROR') {
    return true
  } else {
    return false
  }
}

export const showSSNAsk = (state) => {
  if (!vehicleAndUserExists(state)) return false

  const refi = selectCurrentRefi(state)
  if (!refi.id) return false

  if (refi.loan.decision === 'NO_FILE') {
    return true
  } else {
    return false
  }
}
